<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="flex items-center"
            v-if="!modeTemplate"
          >
            <input
              class='k-checkbox !mr-2 checkbox-lg'
              type='checkbox'
              v-model="checkall"
              @click="changeAllCheckbox(!checkall)"
            />
            <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">Marcar todos los campos</label>
          </div>

          <base-collapsible-form 
            v-if="!disableTipoLibre"
            ref="baseCollapsibleConfigLicenciamiento" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos de licenciamiento"}}</h2>
            </template>
            <template slot="content">

            
          <div class="lg:mb-0">
            <div class="flex -mx-2 flex-col lg:flex-row">
            <div class="flex items-center px-2 w-full lg:mb-0">
              <input
                v-if="!modeTemplate"
                class='k-checkbox !mr-2 checkbox-lg '
                type='checkbox'
                v-model="valuesCheckbox.NumNEOs"
              />
                <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.num_neos')}}
                    <el-form-item prop="NumNEOs">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumNEOs"
                        maxlength='7'
                      >
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
              </div>
            <div class="flex items-center px-2 w-full lg:mb-0">
              <input
                v-if="!modeTemplate"
                class='k-checkbox !mr-2 checkbox-lg '
                type='checkbox'
                v-model="valuesCheckbox.StoredSpace"
              />
                <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.stored_space')}}
                    <el-form-item prop="StoredSpace">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.StoredSpace"
                        maxlength='7'
                      >
                        <template slot="append">MB</template>
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
              </div>
              <div class="flex items-center px-2 w-full lg:mb-0">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg '
                  type='checkbox'
                  v-model="valuesCheckbox.NumSMS"
                />
                <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_sms')}}
                    <el-form-item prop="NumSMS">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumSMS"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>
          </div>

            <div class="mb-2">
              <div class="flex -mx-2 flex-col lg:flex-row">
                <div class="flex items-center px-2 w-full lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.NumLocations"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_locations')}}
                      <el-form-item prop="NumLocations">
                        <el-input
                          clearable
                          class="w-full"
                          v-model.number="form.NumLocations"
                          maxlength='4'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
                <div class="flex items-center px-2 w-full lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.NumCompanies"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_companies')}}
                      <el-form-item prop="NumCompanies">
                        <el-input
                          clearable
                          class="w-full"
                          v-model.number="form.NumCompanies"
                          maxlength='4'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
                <div class="flex items-center px-2 w-full lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.NumeroSedesxCIFEmpresas"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_pgncif')}}
                      <el-form-item prop="NumeroSedesxCIFEmpresas">
                        <el-input
                          clearable
                          class="w-full"
                          v-model.number="form.NumeroSedesxCIFEmpresas"
                          maxlength='7'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
                <div class="flex items-center px-2 w-full lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.NumUsers"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_users')}}
                      <el-form-item prop="NumUsers">
                        <el-input
                          clearable
                          class="w-full"
                          v-model.number="form.NumUsers"
                          maxlength='4'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleConfigGeneral" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.config_general')}}</h2>
            </template>
            <template slot="content">
              
              <div class="flex items-center px-2 w-full mb-4">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg '
                  type='checkbox'
                  v-model="valuesCheckbox.GestionarListaBlancaGrupos"
                />
                <div class="w-full">
                  <label for="switch-gestionar-lista-blanca" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('clients.gestionar_lista_blanca_grupos')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.client')}} / {{$t('app.groups')}}</span>
                  </label>
                  <el-switch 
                    id="switch-gestionar-lista-blanca"
                    :aria-label="$t('clients.gestionar_lista_blanca_grupos')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.GestionarListaBlancaGrupos" 
                    :active-text="$t('app.groups')"
                    :inactive-text="$t('app.client')"
                    inactive-color="var(--primary-800)"/>
                </div>
              </div>

              <div class="flex items-center px-2 w-full mb-4">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg '
                  type='checkbox'
                  v-model="valuesCheckbox.DescargarAcusePDF"
                />
                <div class="w-full">
                  <label for="switch-descargar-acuse" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('clients.descargar_acuse')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-descargar-acuse"
                    :aria-label="$t('clients.descargar_acuse')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.DescargarAcusePDF" 
                    :active-text="$t('companies.active')"/>
                </div>
              </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
              ref="baseCollapsibleConfigMails" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigMails}}</h2>
              </template>
              <template slot="content">
                <div class="flex items-center px-2 w-full mb-4">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.daysGroupsCompanies"
                  />
                  <div class="w-full">
                    <label for="switch-days-groups-companies" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_days_groups_companies')}}
                      <span class="sr-only">{{$t('app.companies')}} / {{$t('app.groups')}}</span>
                    </label>
                    <el-switch 
                      id="switch-days-groups-companies"
                      :aria-label="$t('clients.config_days_groups_companies')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.daysGroupsCompanies" 
                      :inactive-text="$t('app.companies')" 
                      :active-text="$t('app.groups')"
                      inactive-color="var(--primary-800)"
                      />
                  </div>
                </div>
                  
                <div class="flex items-center px-2 w-full mb-4">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.mailsGroupCompanies"
                  />
                  <div class="w-full">
                    <label for="switch-mails-group-companies" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_mails_groups_gestion')}}
                      <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                    </label>
                    <el-switch 
                      id="switch-mails-group-companies"
                      :aria-label="$t('clients.config_mails_groups_gestion')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.mailsGroupCompanies" 
                      :active-text="$t('app.active')" 
                      />
                  </div>
                </div>
                  
                <div class="flex items-center px-2 w-full mb-4">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.mailsTo"
                  />
                  <div class="w-full">
                    <label for="switch-mails-to" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_mails_to')}}
                      <span class="sr-only">{{$t('configurations.mails_to')}} / {{$t('configurations.mails_bcc')}}</span>
                    </label>
                    <el-switch 
                      id="switch-mails-to"
                      :aria-label="$t('clients.config_mails_to')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.mailsTo" 
                      :active-text="$t('configurations.mails_bcc')"
                      :inactive-text="$t('configurations.mails_to')"
                      inactive-color="var(--primary-800)"
                      />
                  </div>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
                ref="baseCollapsibleConfigUsers" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigUsers}}</h2>
                </template>
                <template slot="content">

                <div class="flex items-center px-2 w-full mb-4">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.VincularUsuariosGrupoGestorNEOs"
                  />
                  <div class="w-full">
                    <label for="switch-vincular-usuarios" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_link_user_pool')}}
                      <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                    </label>
                    <el-switch 
                      id="switch-vincular-usuarios"
                      :aria-label="$t('clients.config_link_user_pool')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.VincularUsuariosGrupoGestorNEOs" 
                      :active-text="$t('app.active')" 
                      />
                  </div>
                </div>
                
                <div class="flex items-center px-2 w-full">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.mesesUserPass"
                  />
                  <AccessibleElSelect
                    v-model="form.mesesUserPass"
                    prop="mesesUserPass"
                    :options="mesesUserPassCaducForAccessibleSelect"
                    :withFormItem="true"
                    id-prefix="templateclient"
                  >
                    <template slot="label"><base-obligatory-icon/>{{$t('clients.mesesUserPass')}}</template>
                  </AccessibleElSelect>
                </div>
                
                <div class="mb-6">
                  <div class="flex flex-col lg:flex-row lg:space-x-4">
                    <div class="flex items-center px-2 w-full" v-if="false && hasModuleDobleFactor">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.RequiereOTP"
                      />
                      <div class="w-full">
                        <label for="switch-requiere-otp" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('configurations.client_config_otp')}}
                          <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                        </label>
                        <el-switch 
                          id="switch-requiere-otp"
                          :aria-label="$t('configurations.client_config_otp')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.RequiereOTP"
                          :active-text="$t('app.active')" 
                        />
                      </div>
                    </div>
                    
                    <div class="flex items-center px-2 w-full">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.CambioPassPrimerAcceso"
                      />
                      <div class="w-full">
                        <label for="switch-cambio-pass-primer-acceso" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('configurations.client_config_first_access')}}
                          <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                        </label>
                        <el-switch 
                          id="switch-cambio-pass-primer-acceso"
                          :aria-label="$t('configurations.client_config_first_access')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.CambioPassPrimerAcceso"
                          :active-text="$t('app.active')" 
                          />
                      </div>
                    </div>
                  </div>
                </div>

                </template>
              </base-collapsible-form>
              
          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('configurations.change_mode_template_edit')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_clients')" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_clients')" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
            >
            <p>Se han preseleccionado</p>
            <p>los clientes seleccionados. </p>
          </el-popover>
        </template>
      </base-footer>
      <template-link-clients-dialog 
        ref="templatelinkcompaniesdialog" 
        :title="titleLinkClients" 
        :distributorId="this.id" 
        :dialogOpen="linkToClientsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import { getClientTemplate } from '@/services/clients/getClientTemplate'
import { updateClientTemplate } from '@/services/clients/updateClientTemplate'
import { applyClientTemplate } from '@/services/clients/applyClientTemplate'
import { applyClientKeys } from '@/services/clients/applyClientKeys'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import TemplateLinkClientsDialog from '@/components/TemplateLinkClientsDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

import { i18n } from '@/i18n'
import { MESES_USER_PASS_CADUC } from '@/config/meses-user-pass-caduc'
// import { Upload } from 'element-ui'
// import TextEditor from '@/components/texteditor/TextEditor.vue'
// import { email as emailRegex } from '@/utils/regex'

import { getDistributor } from '@/services/distributors/getDistributor'

function isValidNumLicense (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 9999999) {
      return true
    }
  }
  return false
}
export default {
  /* eslint-disable camelcase */
  name: 'template-client-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkClientsDialog,
    AccessibleElSelect,
    // Upload,
    // TextEditor,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      enableEditCampos: true,
      searchView: false,
      linkToClientsDialog: false,
      activeName: 'es',
      msgHeaderConfigMails: this.$i18n.t('clients.config_admin_mails'),
      msgHeaderConfigUsers: this.$i18n.t('clients.config_admin_users'),
      mesesUserPassCaduc: MESES_USER_PASS_CADUC,
      header: {
        title: i18n.t('distributors.template_clients_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/distributors/details' : 'configurations/clients'
      },
      checkall: false,
      valuesCheckbox: {
        NumNEOs: false,
        StoredSpace: false,
        NumSMS: false,
        NumLocations: false,
        NumCompanies: false,
        NumeroSedesxCIFEmpresas: false,
        NumUsers: false,
        GestionarListaBlancaGrupos: false,
        DescargarAcusePDF: false,
        daysGroupsCompanies: false,
        mailsGroupCompanies: false,
        mailsTo: false,
        VincularUsuariosGrupoGestorNEOs: false,
        mesesUserPass: false,
        RequiereOTP: false,
        CambioPassPrimerAcceso: false,
      },
      form: {
        idClient: null,
        NumNEOs: null,
        StoredSpace: null,
        NumSMS: null,
        NumLocations: null,
        NumCompanies: null,
        NumeroSedesxCIFEmpresas: null,
        NumUsers: null,
        GestionarListaBlancaGrupos: null,
        DescargarAcusePDF: false,
        daysGroupsCompanies: null,
        mailsGroupCompanies: true,
        mailsTo: null,
        VincularUsuariosGrupoGestorNEOs: null,
        mesesUserPass: 0,
        RequiereOTP: false,
        CambioPassPrimerAcceso: false,
      },
      rules: {
        NumNEOs: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        StoredSpace: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumSMS: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumLocations: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumCompanies: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsers: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumeroSedesxCIFEmpresas: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkClients () {
      return this.modeTemplate ? 'Aplicar plantilla a clientes' : 'Aplicar campos seleccionados a clientes'
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor']
    },
    disableTipoLibre () {
      return (this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') &&
       this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    },
    mesesUserPassCaducForAccessibleSelect () {
      return this.mesesUserPassCaduc.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id
      }))
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = this.$i18n.t('configurations.template_header_text_mode')
      else this.header.title = this.$i18n.t('configurations.template_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: this.$i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.distribuidor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.distribuidor.Nombre)
      this.disableRoutes(distributor.distribuidor.idTipoProvisionamiento)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectClients()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template.respuesta)
    }
    this.resetControlFormChanges()
  },
  methods: {
    disableRoutes: function (idTipoProvisionamiento) {
      const objDisableRoutes = {
        disableModules: idTipoProvisionamiento === 1,
        disableLocations: idTipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    isNumberValid: function (rule, value, callback) {
      if ((!value || value === '')) {
        if (rule.field === 'NumSMS') {
          callback()
        }
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      } else if (!isValidNumLicense(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.num_license'), callback)
      } else {
        callback()
      }
    },
    preSelectClients () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.clients) {
        this.$refs.templatelinkcompaniesdialog.changeSelectedCompanies(data.clients)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.NumNEOs = value
      this.valuesCheckbox.StoredSpace = value 
      this.valuesCheckbox.NumSMS = value 
      this.valuesCheckbox.NumLocations = value 
      this.valuesCheckbox.NumCompanies = value
      this.valuesCheckbox.NumeroSedesxCIFEmpresas = value
      this.valuesCheckbox.NumUsers = value
      this.valuesCheckbox.GestionarListaBlancaGrupos = value
      this.valuesCheckbox.DescargarAcusePDF = value
      this.valuesCheckbox.daysGroupsCompanies = value
      this.valuesCheckbox.mailsGroupCompanies = value
      this.valuesCheckbox.mailsTo = value
      this.valuesCheckbox.VincularUsuariosGrupoGestorNEOs = value
      this.valuesCheckbox.mesesUserPass = value
      this.valuesCheckbox.RequiereOTP = value
      this.valuesCheckbox.CambioPassPrimerAcceso = value
    },
    toggleDialogLink: function () {
      this.linkToClientsDialog = !this.linkToClientsDialog
    },
    applyLinkHandler: async function (clients) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateClients('ruleForm', clients)
      } else {
        this.UpdateClientsWithSelected('ruleForm', clients)
      }
    },
    downloadDistributorData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        if (distributor.blnError === true) {
          this.doFeedback(distributor.msgError + ' [Código de error: ' + distributor.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idDistribuidor: this.id,
            NumeroSedes: this.disableTipoLibre ? null : this.form.NumLocations,
            NumeroCIFEmpresas: this.disableTipoLibre ? null : this.form.NumCompanies,
            NumeroUsuarios: this.disableTipoLibre ? null : this.form.NumUsers,
            NumeroNotificacionesAnuales: this.disableTipoLibre ? null : this.form.NumNEOs,
            EspacioTotal: this.disableTipoLibre ? null : this.form.StoredSpace,
            NumeroSedesxCIFEmpresas: this.disableTipoLibre ? null : this.form.NumeroSedesxCIFEmpresas,
            NumeroSMS: this.disableTipoLibre ? null : this.form.NumSMS,
            GestionarListaBlancaGrupos: this.form.GestionarListaBlancaGrupos,
            DescargarAcusePDF: this.form.DescargarAcusePDF,
            EnviarMailCopiaOculta: this.form.mailsTo,
            EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
            GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
            VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
            MesesUserPass: this.form.mesesUserPass,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
          }
          const response = await updateClientTemplate({ idDistribuidor: this.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateClients: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idDistribuidor: this.id,
            NumeroSedes: this.disableTipoLibre ? null : this.form.NumLocations,
            NumeroCIFEmpresas: this.disableTipoLibre ? null : this.form.NumCompanies,
            NumeroUsuarios: this.disableTipoLibre ? null : this.form.NumUsers,
            NumeroNotificacionesAnuales: this.disableTipoLibre ? null : this.form.NumNEOs,
            EspacioTotal: this.disableTipoLibre ? null : this.form.StoredSpace,
            NumeroSedesxCIFEmpresas: this.disableTipoLibre ? null : this.form.NumeroSedesxCIFEmpresas,
            NumeroSMS: this.disableTipoLibre ? null : this.form.NumSMS,
            GestionarListaBlancaGrupos: this.form.GestionarListaBlancaGrupos,
            DescargarAcusePDF: this.form.DescargarAcusePDF,
            EnviarMailCopiaOculta: this.form.mailsTo,
            EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
            GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
            VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
            MesesUserPass: this.form.mesesUserPass,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
          }
          this.toggleDialogLink()
          const response = await updateClientTemplate({ idDistribuidor: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
            const response = await applyClientTemplate({ idDistribuidor: this.id }, clients)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Clientes actualizados correctamente', 'success')
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateClientsWithSelected: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idDistribuidor: this.id,
            idClientes: clients,

            checkNumeroSedes: this.disableTipoLibre ? null : this.valuesCheckbox.NumLocations,
            checkNumeroCIFEmpresas: this.disableTipoLibre ? null : this.valuesCheckbox.NumCompanies,
            checkNumeroUsuarios: this.disableTipoLibre ? null : this.valuesCheckbox.NumUsers,
            checkNumeroNotificacionesAnuales: this.disableTipoLibre ? null : this.valuesCheckbox.NumNEOs,
            checkEspacioTotal: this.disableTipoLibre ? null : this.valuesCheckbox.StoredSpace,
            checkNumeroSedesxCIFEmpresas: this.disableTipoLibre ? null : this.valuesCheckbox.NumeroSedesxCIFEmpresas,
            checkNumeroSMS: this.disableTipoLibre ? null : this.valuesCheckbox.NumSMS,
            checkGestionarListaBlancaGrupos: this.valuesCheckbox.GestionarListaBlancaGrupos,
            checkDescargarAcusePDF: this.valuesCheckbox.DescargarAcusePDF,
            checkEnviarMailCopiaOculta: this.valuesCheckbox.mailsTo,
            checkEnviarMailGruposNoPropietarios: this.valuesCheckbox.mailsGroupCompanies,
            checkGestionarDiasAvisosGrupos: this.valuesCheckbox.daysGroupsCompanies,
            checkVincularUsuariosGrupoGestorNEOs: this.valuesCheckbox.VincularUsuariosGrupoGestorNEOs,
            checkMesesUserPass: this.valuesCheckbox.mesesUserPass,
            checkRequiereOTP: this.valuesCheckbox.RequiereOTP,
            checkCambioPassPrimerAcceso: this.valuesCheckbox.CambioPassPrimerAcceso,

            NumeroSedes: this.disableTipoLibre ? null :this.form.NumLocations,
            NumeroCIFEmpresas: this.disableTipoLibre ? null :this.form.NumCompanies,
            NumeroUsuarios: this.disableTipoLibre ? null :this.form.NumUsers,
            NumeroNotificacionesAnuales: this.disableTipoLibre ? null : this.form.NumNEOs,
            EspacioTotal: this.disableTipoLibre ? null :this.form.StoredSpace,
            NumeroSedesxCIFEmpresas: this.disableTipoLibre ? null :this.form.NumeroSedesxCIFEmpresas,
            NumeroSMS: this.disableTipoLibre ? null :this.form.NumSMS,
            GestionarListaBlancaGrupos: this.form.GestionarListaBlancaGrupos,
            DescargarAcusePDF: this.form.DescargarAcusePDF,
            EnviarMailCopiaOculta: this.form.mailsTo,
            EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
            GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
            VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
            MesesUserPass: this.form.mesesUserPass,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
          }
          this.toggleDialogLink()
          const response = await applyClientKeys({ idDistribuidor: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Clientes actualizados correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/distributors/details', params: this.id })
      else this.$router.push({ name: 'configurations/clients' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getClientTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (template) {
      if (template) {
        this.form.NumSMS = template.NumeroSMS ? template.NumeroSMS : null
        this.form.NumNEOs = template.NumeroNotificacionesAnuales ? template.NumeroNotificacionesAnuales : null
        this.form.StoredSpace = template.EspacioTotal ? template.EspacioTotal : null
        this.form.NumLocations = template.NumeroSedes ? template.NumeroSedes : null
        this.form.NumCompanies = template.NumeroCIFEmpresas ? template.NumeroCIFEmpresas : null
        this.form.NumeroSedesxCIFEmpresas = template.NumeroSedesxCIFEmpresas ? template.NumeroSedesxCIFEmpresas : null
        this.form.NumUsers = template.NumeroUsuarios ? template.NumeroUsuarios : null
        this.form.GestionarListaBlancaGrupos = template.GestionarListaBlancaGrupos ? template.GestionarListaBlancaGrupos : null
        this.form.DescargarAcusePDF = template.DescargarAcusePDF ? template.DescargarAcusePDF : null
        this.form.daysGroupsCompanies = template.GestionarDiasAvisosGrupos ? template.GestionarDiasAvisosGrupos : null
        this.form.mailsGroupCompanies = template.EnviarMailGruposNoPropietarios ? template.EnviarMailGruposNoPropietarios : true
        this.form.mailsTo = template.EnviarMailCopiaOculta ? template.EnviarMailCopiaOculta : null
        this.form.VincularUsuariosGrupoGestorNEOs = template.VincularUsuariosGrupoGestorNEOs ? template.VincularUsuariosGrupoGestorNEOs : null
        this.form.mesesUserPass = template.MesesUserPass ? template.MesesUserPass : 0
        this.form.RequiereOTP = template.RequiereOTP ? template.RequiereOTP : null
        this.form.CambioPassPrimerAcceso = template.CambioPassPrimerAcceso ? template.CambioPassPrimerAcceso : null
      }
      this.resetControlFormChanges()
    }
  }

}
</script>
